const autoNgTemplateLoaderTemplate1 = require('./eventsDatatable.html');

angular.module('portainer.kubernetes').component('kubernetesEventsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    loading: '<',
    refreshCallback: '<',
  },
});
